var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{class:{'btnCreate': true, btn: true},attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportExcel}},[_vm._v("下载表格")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }